import { CourseItem, LessonItem } from '@atlassian/learning-components';

import { SUBNAVBAR_HEIGHT } from 'src/pages/LessonPage/utils/utils';

export const scrollToSection = (section: HTMLElement | null, isCourse: boolean): void => {
  if (typeof window === 'undefined' || !section) {
    return;
  }

  window.scrollTo({
    top: section.offsetTop - (isCourse ? SUBNAVBAR_HEIGHT : SUBNAVBAR_HEIGHT * 2),
    behavior: 'smooth',
  });
};

export const addQuizToLesson = (lesson: LessonItem): LessonItem => ({
  ...lesson,
  sectionListCollection: {
    items: [
      ...(lesson.sectionListCollection?.items || []).map((section) => ({
        ...section,
      })),
      {
        id: 'quiz',
        title: 'Quiz',
        sys: {
          id: 'quiz',
        },
      },
    ],
  },
});

export const addQuizToLessons = (course: CourseItem): CourseItem => ({
  ...course,
  lessonsCollection: {
    items: course.lessonsCollection?.items?.map(addQuizToLesson),
  },
});
